
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $c1f0808e2e94bde6$exports = {};
$c1f0808e2e94bde6$exports = JSON.parse('[{"id":"snake-plant","name":"Snake Plant","botanical":"Dracaena trifasciata","price":14,"light":["low","medium","bright"],"water":["forgetful","regular"],"petSafe":false,"personality":"Survives neglect, gloom, and your longest holidays \u2014 mostly by ignoring you."},{"id":"golden-pothos","name":"Golden Pothos","botanical":"Epipremnum aureum","price":12,"light":["low","medium","bright"],"water":["forgetful","regular"],"petSafe":false,"personality":"Grows a metre of vine a year and asks for almost nothing in return."},{"id":"zz-plant","name":"ZZ Plant","botanical":"Zamioculcas zamiifolia","price":18,"light":["low","medium"],"water":["forgetful"],"petSafe":false,"personality":"Runs on stored water and stubbornness; watering it weekly is the only way to lose it."},{"id":"spider-plant","name":"Spider Plant","botanical":"Chlorophytum comosum","price":10,"light":["medium","bright"],"water":["forgetful","regular"],"petSafe":true,"personality":"Churns out baby plants faster than you can rehome them."},{"id":"boston-fern","name":"Boston Fern","botanical":"Nephrolepis exaltata","price":16,"light":["medium"],"water":["attentive"],"petSafe":true,"personality":"Lush, dramatic, and thirsty \u2014 skip two waterings and it sheds like a headline."},{"id":"calathea","name":"Calathea Orbifolia","botanical":"Goeppertia orbifolia","price":22,"light":["low","medium"],"water":["attentive"],"petSafe":true,"personality":"Folds its striped leaves up each night and silently judges your tap water."},{"id":"parlour-palm","name":"Parlour Palm","botanical":"Chamaedorea elegans","price":15,"light":["low","medium"],"water":["regular"],"petSafe":true,"personality":"Has tolerated dim Victorian parlours since 1850; your hallway is no challenge."},{"id":"aloe-vera","name":"Aloe Vera","botanical":"Aloe barbadensis miller","price":9,"light":["bright"],"water":["forgetful"],"petSafe":false,"personality":"Wants your sunniest sill, a drink a month, and otherwise total independence."}]');


var $bc75c79582e00e04$exports = {};
$bc75c79582e00e04$exports = JSON.parse('{"questions":[{"id":"light","legend":"How bright is your place?","hint":"Judge the exact spot the plant will live in, not the room\'s best hour.","options":[{"value":"low","label":"Gloomy","description":"North-facing, or a good stretch from the window","icon":"cloud"},{"value":"medium","label":"Decent","description":"A bright room, but no direct sun on the spot","icon":"sun-cloud"},{"value":"bright","label":"Sun-drenched","description":"Direct sun on the sill for a few hours a day","icon":"sun"}]},{"id":"care","legend":"What\'s your watering track record?","hint":"Be honest \u2014 the plants already know.","options":[{"value":"forgetful","label":"Forgetful","description":"Weeks can slip by; the watering can gathers dust","icon":"droplet-sleep"},{"value":"regular","label":"Steady","description":"A reliable round with the can most weekends","icon":"watering-can"},{"value":"attentive","label":"Devoted","description":"Misting, moisture checks, leaf-wiping \u2014 the full spa","icon":"mister"}]},{"id":"pets","legend":"Any nibbling housemates?","hint":"Cats, dogs, rabbits \u2014 anyone who treats houseplants as salad.","options":[{"value":"yes","label":"Pets about","description":"Only show plants that are safe to nibble","icon":"paw"},{"value":"no","label":"No pets","description":"The whole bench is fair game","icon":"house"}]}],"reasons":{"light":{"low":"Genuinely copes with low light","medium":"Happy in decent indirect light","bright":"Loves a bright, sunny sill"},"care":{"forgetful":"Forgives missed waterings","regular":"Content with a weekly water","attentive":"Repays the fussing \u2014 misting and all"},"pets":{"yes":"Non-toxic to cats and dogs"}},"mismatches":{"light":{"brighter":"Honestly wants more light than you\'ve got \u2014 give it your brightest spot and expect slower growth","dimmer":"Prefers softer light than a blazing sill \u2014 set it a step back from the glass"},"care":{"more":"Wants steadier watering than you\'re promising \u2014 a phone reminder would save it","less":"Easy to love to death \u2014 water it half as often as you\'re tempted to"}},"tagLabels":{"light":{"low":"Low light","medium":"Medium light","bright":"Bright light"},"water":{"forgetful":"Forgives forgetting","regular":"Weekly water","attentive":"Wants devotion"},"petSafe":"Pet-safe","notPetSafe":"Keep from pets"}}');


var $b23191685ef07c6c$exports = {};
$b23191685ef07c6c$exports = JSON.parse('{"name":"The Unkillables","city":"Bristol","tagline":"Plants matched to your habits, not your aspirations.","email":"hello@theunkillables.example","address":"14 Cotham Hill, Bristol BS6 6LF","currencySymbol":"\xa3","hours":[{"days":"Tue \u2013 Fri","time":"10:00 \u2013 18:00"},{"days":"Saturday","time":"9:00 \u2013 17:00"},{"days":"Sun \u2013 Mon","time":"Closed (watering day)"}],"navigation":[{"label":"The quiz","href":"#quiz"},{"label":"The bench","href":"#catalogue"},{"label":"FAQ","href":"#faq"},{"label":"Visit","href":"#visit"}],"socials":[{"label":"Instagram","href":"https://instagram.com/theunkillables"}],"emailButtonLabel":"Email the shop","sections":{"quiz":{"kicker":"A plant shop that tells the truth","title":"Will it survive?","lede":"Three questions about your flat \u2014 the light, your watering track record, and who else lives there \u2014 and we\'ll show you only the plants that will actually cope. No aspirational ferns, no guilt.","urlNote":"Your answers update the page address, so you can send your results to whoever waters the plants when you\'re away.","benchLine":"The whole bench: eight plants, honestly tagged."},"results":{"kicker":"Your matches","title":"The survivors","placeholderTitle":"No verdict yet","placeholderBody":"The survivors appear here once we know your light, your watering habits, and your housemates.","progressTemplate":"{answered} of 3 questions answered.","completeTemplate":"{count} survivors found for your answers.","honestyNote":"Matches come from the care tags on this page, not live stock \u2014 email before you cross town and we\'ll confirm what\'s on the bench.","fallbackNote":"Straight talk: nothing on the bench ticks every box for that combination. These are the closest survivors, with the catch spelled out.","closeFlag":"Close call","copyLinkLabel":"Copy link to these results","copiedLabel":"Link copied","copyFailedLabel":"Copying failed \u2014 share the address bar instead","reserveLabel":"Reserve one"},"catalogue":{"kicker":"The whole bench","title":"Every plant we stock","lede":"Eight plants, tagged honestly. This is a bench, not a warehouse \u2014 what you see is the shortlist we actually stand behind.","reserveLabel":"Reserve one"},"faq":{"kicker":"Before you email","title":"Fair questions"},"visit":{"kicker":"Find us","title":"Come and squint at a leaf","lede":"Bring a photo of the corner you\'re trying to fill \u2014 we\'ll tell you honestly what will cope there, even if the answer is a candle.","addressTitle":"The shop","hoursTitle":"Opening hours","emailLead":"Reserving, asking, or sending a photo of a sad fern:"},"footer":{"line":"Every plant leaves with a care card and a fighting chance.","smallPrint":"Quiz results are guidance from our care tags, not a live stock check."}},"reserve":{"subject":"Reserving a {plant}","body":"Hi {shop},\\n\\nThe quiz says a {plant} ({botanical}) would survive my place \u2014 could you set one aside?\\n\\nName:\\nPickup day:\\n\\nThanks!"},"faqs":[{"question":"Are the quiz results checked against live stock?","answer":"No \u2014 matches come from the care tags on this page, not a stock system. The bench changes weekly, so email us with the plant name and we\'ll confirm what\'s actually here and put one aside."},{"question":"What does the pet-safe tag mean?","answer":"Pet-safe plants are ones widely listed as non-toxic to cats and dogs. A nibble shouldn\'t cause harm \u2014 but no plant enjoys being a salad, so still keep leaves out of reach of committed grazers."},{"question":"Can you hold a plant for me?","answer":"Yes. Send the reserve email from any plant card and we\'ll keep one on the bench with your name on it for three days. No deposit \u2014 if you change your mind, just tell us."},{"question":"Every plant I\'ve owned has died. Is it hopeless?","answer":"It\'s almost always too much water or too little light, not a curse. Answer the quiz honestly \u2014 especially the watering question \u2014 and start with whatever it suggests. Our unofficial record is four snake plants thriving in one very dark flat."},{"question":"Do you deliver?","answer":"Within Bristol, yes \u2014 we do a cargo-bike round on Fridays. Mention delivery in your email and we\'ll confirm a slot. Further afield, plants travel badly and we\'d rather be honest about that."}]}');


const $639c424d7abca305$export$6193722c8094ee5f = (0, (/*@__PURE__*/$parcel$interopDefault($b23191685ef07c6c$exports)));
const $639c424d7abca305$export$1ce40965716f5168 = (0, (/*@__PURE__*/$parcel$interopDefault($c1f0808e2e94bde6$exports)));
const $639c424d7abca305$export$8d0bb65fc38d32db = (0, (/*@__PURE__*/$parcel$interopDefault($bc75c79582e00e04$exports)));


const $268f2417e2e7b740$var$INK = '#2b3a2e';
const $268f2417e2e7b740$var$SUN = '#e9b24c';
const $268f2417e2e7b740$var$CLOUD = '#c8d4cd';
const $268f2417e2e7b740$var$WATER = '#7fb3c8';
const $268f2417e2e7b740$var$TERRACOTTA = '#c9683f';
const $268f2417e2e7b740$var$LEAF = '#4c8f5c';
const $268f2417e2e7b740$var$AMBER = '#b97f24';
function $268f2417e2e7b740$var$svg(body, viewBox = '0 0 48 48') {
    return `<svg viewBox="${viewBox}" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">${body}</svg>`;
}
const $268f2417e2e7b740$export$29eafeec5feb04d7 = {
    cloud: $268f2417e2e7b740$var$svg(`<path d="M14 34 a8 8 0 0 1 -1 -15.9 a10.5 10.5 0 0 1 20.4 -1.4 A8.5 8.5 0 0 1 33 34 Z" fill="${$268f2417e2e7b740$var$CLOUD}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linejoin="round"/>
     <path d="M12 41 h6 M22 41 h6 M32 41 h4" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round" opacity="0.45"/>`),
    'sun-cloud': $268f2417e2e7b740$var$svg(`<circle cx="31" cy="17" r="7.5" fill="${$268f2417e2e7b740$var$SUN}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5"/>
     <path d="M31 4.5 v4 M40 8.5 l-2.8 2.8 M43.5 17 h-4" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round"/>
     <path d="M10 38 a7 7 0 0 1 -0.8 -13.9 a9 9 0 0 1 17.6 -1.2 A7.3 7.3 0 0 1 26.5 38 Z" fill="${$268f2417e2e7b740$var$CLOUD}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linejoin="round"/>`),
    sun: $268f2417e2e7b740$var$svg(`<circle cx="24" cy="24" r="9.5" fill="${$268f2417e2e7b740$var$SUN}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5"/>
     <path d="M24 5 v5 M24 38 v5 M5 24 h5 M38 24 h5 M10.6 10.6 l3.5 3.5 M33.9 33.9 l3.5 3.5 M37.4 10.6 l-3.5 3.5 M14.1 33.9 l-3.5 3.5" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round"/>`),
    'droplet-sleep': $268f2417e2e7b740$var$svg(`<path d="M20 8 C25 16 31 22 31 30 a11 11 0 0 1 -22 0 C9 22 15 16 20 8 Z" fill="none" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linejoin="round"/>
     <path d="M33 10 h7 l-7 7 h7" stroke="${$268f2417e2e7b740$var$AMBER}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
     <path d="M36 26 h5 l-5 5 h5" stroke="${$268f2417e2e7b740$var$AMBER}" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" fill="none" opacity="0.8"/>`),
    'watering-can': $268f2417e2e7b740$var$svg(`<rect x="14" y="18" width="18" height="16" rx="4" fill="${$268f2417e2e7b740$var$LEAF}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5"/>
     <path d="M32 22 l9 -6 M41 16 l-1.5 5" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round"/>
     <path d="M32 24 l8 -5.4 a2.6 2.6 0 0 1 2 4.6 l-4 3" fill="${$268f2417e2e7b740$var$LEAF}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linejoin="round"/>
     <path d="M14 24 h-3 a5 5 0 0 0 0 10 h3" fill="none" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round"/>
     <path d="M20 14 a4 4 0 0 1 8 0" fill="none" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round"/>
     <path d="M40 28 c0 2 -1.6 3.4 -1.6 5 a1.8 1.8 0 0 0 3.6 0 c0 -1.6 -2 -3 -2 -5 Z" fill="${$268f2417e2e7b740$var$WATER}"/>`),
    mister: $268f2417e2e7b740$var$svg(`<path d="M17 20 h10 l-1.5 20 a3 3 0 0 1 -3 2.8 h-4 a3 3 0 0 1 -3 -2.8 Z" fill="${$268f2417e2e7b740$var$LEAF}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linejoin="round"/>
     <path d="M19 20 v-5 a3 3 0 0 1 3 -3 h7" fill="none" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round"/>
     <path d="M29 9 h5 a2.5 2.5 0 0 1 0 6 h-3" fill="none" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
     <circle cx="40" cy="9" r="1.7" fill="${$268f2417e2e7b740$var$WATER}"/>
     <circle cx="43" cy="14" r="1.7" fill="${$268f2417e2e7b740$var$WATER}"/>
     <circle cx="40" cy="19" r="1.7" fill="${$268f2417e2e7b740$var$WATER}"/>`),
    paw: $268f2417e2e7b740$var$svg(`<ellipse cx="14" cy="16" rx="4.4" ry="5.6" fill="${$268f2417e2e7b740$var$TERRACOTTA}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.2"/>
     <ellipse cx="24" cy="12.5" rx="4.4" ry="5.6" fill="${$268f2417e2e7b740$var$TERRACOTTA}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.2"/>
     <ellipse cx="34" cy="16" rx="4.4" ry="5.6" fill="${$268f2417e2e7b740$var$TERRACOTTA}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.2"/>
     <path d="M24 24 c6.5 0 12 4.6 12 10.2 c0 4 -3.2 6.3 -6.6 5.3 c-2.3 -0.7 -3.4 -1 -5.4 -1 s-3.1 0.3 -5.4 1 c-3.4 1 -6.6 -1.3 -6.6 -5.3 C12 28.6 17.5 24 24 24 Z" fill="${$268f2417e2e7b740$var$TERRACOTTA}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.2" stroke-linejoin="round"/>`),
    house: $268f2417e2e7b740$var$svg(`<path d="M8 22 L24 8 L40 22" fill="none" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
     <path d="M12 20 v18 a2 2 0 0 0 2 2 h20 a2 2 0 0 0 2 -2 V20" fill="none" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.5" stroke-linejoin="round"/>
     <path d="M20 40 v-9 a2 2 0 0 1 2 -2 h4 a2 2 0 0 1 2 2 v9" fill="${$268f2417e2e7b740$var$TERRACOTTA}" stroke="${$268f2417e2e7b740$var$INK}" stroke-width="2.2" stroke-linejoin="round"/>`)
};
const $268f2417e2e7b740$export$58d09ec3e03f3a63 = $268f2417e2e7b740$var$svg(`<path d="M9 1.5 C4 3 1.5 6.5 2 11 c0.2 1.8 0.8 3 2 4.5 C6 13 8 12 11 11.5 C8.5 12.8 6.8 14 5.5 16.5 c1.5 0.8 3 1 4.5 0.8 c4.5 -0.7 6.5 -5 5.5 -10 C14.8 4 12.5 2 9 1.5 Z" fill="#4c8f5c"/>`, '0 0 18 18');
const $268f2417e2e7b740$export$d37638154c887af2 = $268f2417e2e7b740$var$svg(`<path d="M9 2 a2.2 2.2 0 0 1 1.9 1.1 l6 10.4 A2.2 2.2 0 0 1 15 16.8 H3 a2.2 2.2 0 0 1 -1.9 -3.3 l6 -10.4 A2.2 2.2 0 0 1 9 2 Z" fill="#e9b24c"/>
   <path d="M9 6.5 v4.2" stroke="#2b3a2e" stroke-width="1.8" stroke-linecap="round"/>
   <circle cx="9" cy="13.6" r="1.1" fill="#2b3a2e"/>`, '0 0 18 18');
const $268f2417e2e7b740$export$63cea22b3e24bc8 = $268f2417e2e7b740$var$svg(`<rect x="2" y="4" width="16" height="12" rx="2.5" fill="none" stroke="currentColor" stroke-width="1.8"/>
   <path d="M3.5 6.5 L10 11.5 L16.5 6.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>`, '0 0 20 20');
const $268f2417e2e7b740$export$ebcd2be1028c1c9c = $268f2417e2e7b740$var$svg(`<path d="M8.5 11.5 a4 4 0 0 1 0 -5.6 l3 -3 a4 4 0 0 1 5.6 5.6 l-1.8 1.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
   <path d="M11.5 8.5 a4 4 0 0 1 0 5.6 l-3 3 a4 4 0 0 1 -5.6 -5.6 l1.8 -1.8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>`, '0 0 20 20');
const $268f2417e2e7b740$export$fb9188ad99e3f6b = $268f2417e2e7b740$var$svg(`<path d="M3 10 h13 M11 5 l5 5 -5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>`, '0 0 20 20');
const $268f2417e2e7b740$export$9d5c241fe9ee2567 = $268f2417e2e7b740$var$svg(`<circle cx="24" cy="24" r="22" fill="#f6ead2"/>
   <path d="M24 25 C22.5 18 17 15 11.5 16.5 C13 22 18 25.5 23.5 25.6 Z" fill="#4c8f5c"/>
   <path d="M24 25 C25.5 17 31 12.5 37.5 14.5 C36 21.5 30 25.6 24.5 25.6 Z" fill="#2c5e3a"/>
   <path d="M23.3 15 h1.6 v11 h-1.6 Z" fill="#2c5e3a"/>
   <rect x="13" y="26" width="22" height="5" rx="2.5" fill="#a94f2c"/>
   <path d="M16 31 h16 l-2.2 9.5 a2.4 2.4 0 0 1 -2.3 1.9 h-7 a2.4 2.4 0 0 1 -2.3 -1.9 Z" fill="#c9683f"/>`);


/**
 * Original flat-vector potted-plant illustrations, one per plant id in
 * src/data/plants.json. Every drawing shares the same backdrop circle,
 * terracotta pot, and palette so the set reads as one hand.
 */ const $eb192a108979e5f5$var$POT = '#c9683f';
const $eb192a108979e5f5$var$POT_DARK = '#a94f2c';
const $eb192a108979e5f5$var$POT_LIGHT = '#e08b5e';
const $eb192a108979e5f5$var$BACKDROP = '#f6ead2';
const $eb192a108979e5f5$var$GREEN_DEEP = '#2c5e3a';
const $eb192a108979e5f5$var$GREEN_MID = '#4c8f5c';
const $eb192a108979e5f5$var$GREEN_LIGHT = '#8fc49a';
const $eb192a108979e5f5$var$SUN_EDGE = '#e9b24c';
const $eb192a108979e5f5$var$GOLD_FLECK = '#e8d493';
const $eb192a108979e5f5$var$PLUM = '#7c4a5e';
const $eb192a108979e5f5$var$PLUM_STRIPE = '#c9a0b0';
const $eb192a108979e5f5$var$STOLON = '#c9a45f';
const $eb192a108979e5f5$var$SHADOW = 'rgba(43, 58, 46, 0.12)';
function $eb192a108979e5f5$var$pot() {
    return `
    <ellipse cx="80" cy="152" rx="33" ry="4.5" fill="${$eb192a108979e5f5$var$SHADOW}"/>
    <path d="M52 114 L108 114 L102.5 146 Q101.8 152 95.5 152 L64.5 152 Q58.2 152 57.5 146 Z" fill="${$eb192a108979e5f5$var$POT}"/>
    <rect x="63" y="119" width="6" height="25" rx="3" fill="${$eb192a108979e5f5$var$POT_LIGHT}" opacity="0.55"/>
    <rect x="44" y="100" width="72" height="14" rx="7" fill="${$eb192a108979e5f5$var$POT_DARK}"/>`;
}
function $eb192a108979e5f5$var$wrap(foliage, overlay = '') {
    return `<svg viewBox="0 0 160 160" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><circle cx="80" cy="82" r="74" fill="${$eb192a108979e5f5$var$BACKDROP}"/>${foliage}${$eb192a108979e5f5$var$pot()}${overlay}</svg>`;
}
function $eb192a108979e5f5$var$ellipseLeaf(x, y, angle, rx, ry, fill) {
    return `<ellipse cx="${x}" cy="${y}" rx="${rx}" ry="${ry}" fill="${fill}" transform="rotate(${angle} ${x} ${y})"/>`;
}
function $eb192a108979e5f5$var$quadPoint(p0, p1, p2, t) {
    const inv = 1 - t;
    return [
        inv * inv * p0[0] + 2 * inv * t * p1[0] + t * t * p2[0],
        inv * inv * p0[1] + 2 * inv * t * p1[1] + t * t * p2[1]
    ];
}
function $eb192a108979e5f5$var$quadNormal(p0, p1, p2, t) {
    const inv = 1 - t;
    const dx = 2 * inv * (p1[0] - p0[0]) + 2 * t * (p2[0] - p1[0]);
    const dy = 2 * inv * (p1[1] - p0[1]) + 2 * t * (p2[1] - p1[1]);
    const length = Math.hypot(dx, dy) || 1;
    return [
        -dy / length,
        dx / length
    ];
}
function $eb192a108979e5f5$var$round(value) {
    return Math.round(value * 10) / 10;
}
/* --- Snake plant: upright sword leaves with pale stripes and gold margins. */ function $eb192a108979e5f5$var$snakePlant() {
    const leaves = [
        {
            d: 'M70 102 C66 72 68 44 74 30 C77 44 77 74 79 102 Z',
            edge: false
        },
        {
            d: 'M80 102 C79 62 82 32 87 22 C91 40 89 72 90 102 Z',
            edge: true
        },
        {
            d: 'M60 102 C56 84 58 62 65 50 C68 64 66 86 68 102 Z',
            edge: false
        },
        {
            d: 'M91 102 C92 76 96 52 103 42 C105 58 100 84 98 102 Z',
            edge: true
        },
        {
            d: 'M102 102 C103 90 107 76 112 70 C113 80 110 94 107 102 Z',
            edge: false
        }
    ];
    const stripes = [
        'M73 96 C71 72 72 50 75 38',
        'M84 96 C83 64 84 40 86 30',
        'M96 96 C97 74 99 56 101 48',
        'M63 96 C61 80 62 64 65 56'
    ];
    const shapes = leaves.map((leaf)=>`<path d="${leaf.d}" fill="${$eb192a108979e5f5$var$GREEN_DEEP}"${leaf.edge ? ` stroke="${$eb192a108979e5f5$var$SUN_EDGE}" stroke-width="1.8"` : ''}/>`).join('');
    const details = stripes.map((d)=>`<path d="${d}" fill="none" stroke="${$eb192a108979e5f5$var$GREEN_LIGHT}" stroke-width="2.2" stroke-linecap="round"/>`).join('');
    return $eb192a108979e5f5$var$wrap(shapes + details);
}
/* --- Golden pothos: mound of heart leaves plus two trailing vines. */ const $eb192a108979e5f5$var$HEART = 'M0 -4 C -8 -16 -24 -10 -22 2 C -20 12 -9 15 0 24 C 9 15 20 12 22 2 C 24 -10 8 -16 0 -4 Z';
function $eb192a108979e5f5$var$heartLeaf(x, y, angle, scale, fill, fleck = false) {
    const flecks = fleck ? `<ellipse cx="-5" cy="5" rx="4" ry="2" fill="${$eb192a108979e5f5$var$GOLD_FLECK}" transform="rotate(-24 -5 5)"/><ellipse cx="6" cy="9" rx="2.6" ry="1.4" fill="${$eb192a108979e5f5$var$GOLD_FLECK}" transform="rotate(14 6 9)"/>` : '';
    return `<g transform="translate(${x} ${y}) rotate(${angle}) scale(${scale})"><path d="${$eb192a108979e5f5$var$HEART}" fill="${fill}"/>${flecks}</g>`;
}
function $eb192a108979e5f5$var$goldenPothos() {
    const mound = [
        $eb192a108979e5f5$var$heartLeaf(58, 80, -30, 1, $eb192a108979e5f5$var$GREEN_DEEP),
        $eb192a108979e5f5$var$heartLeaf(102, 80, 24, 1, $eb192a108979e5f5$var$GREEN_DEEP, true),
        $eb192a108979e5f5$var$heartLeaf(70, 62, -18, 0.72, $eb192a108979e5f5$var$GREEN_LIGHT),
        $eb192a108979e5f5$var$heartLeaf(80, 70, -5, 1.05, $eb192a108979e5f5$var$GREEN_MID, true),
        $eb192a108979e5f5$var$heartLeaf(68, 92, -55, 0.75, $eb192a108979e5f5$var$GREEN_MID),
        $eb192a108979e5f5$var$heartLeaf(96, 92, 48, 0.78, $eb192a108979e5f5$var$GREEN_MID)
    ].join('');
    const vines = `
    <path d="M58 104 C 42 112 32 126 40 144" fill="none" stroke="${$eb192a108979e5f5$var$GREEN_DEEP}" stroke-width="2.6" stroke-linecap="round"/>
    ${$eb192a108979e5f5$var$heartLeaf(43, 128, -18, 0.5, $eb192a108979e5f5$var$GREEN_MID)}
    ${$eb192a108979e5f5$var$heartLeaf(40, 144, 8, 0.42, $eb192a108979e5f5$var$GREEN_DEEP)}
    <path d="M102 104 C 120 112 128 128 120 146" fill="none" stroke="${$eb192a108979e5f5$var$GREEN_DEEP}" stroke-width="2.6" stroke-linecap="round"/>
    ${$eb192a108979e5f5$var$heartLeaf(118, 130, 20, 0.5, $eb192a108979e5f5$var$GREEN_DEEP, true)}
    ${$eb192a108979e5f5$var$heartLeaf(120, 146, -6, 0.42, $eb192a108979e5f5$var$GREEN_MID)}`;
    return $eb192a108979e5f5$var$wrap(mound, vines);
}
/* --- ZZ plant: arched stems lined with glossy oval leaflets. */ function $eb192a108979e5f5$var$zzPlant() {
    const stems = [
        'M70 102 C 62 76 64 46 76 30',
        'M84 102 C 84 72 90 48 98 36',
        'M60 102 C 52 86 50 68 56 54'
    ].map((d)=>`<path d="${d}" fill="none" stroke="${$eb192a108979e5f5$var$GREEN_DEEP}" stroke-width="3.4" stroke-linecap="round"/>`).join('');
    const leaflets = [
        [
            61,
            84,
            -40,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            72,
            78,
            -12,
            $eb192a108979e5f5$var$GREEN_LIGHT
        ],
        [
            60,
            66,
            -40,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            71,
            58,
            -12,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            63,
            46,
            -35,
            $eb192a108979e5f5$var$GREEN_LIGHT
        ],
        [
            74,
            38,
            -8,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            76,
            28,
            -20,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            79,
            86,
            -18,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            91,
            78,
            25,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            82,
            68,
            -12,
            $eb192a108979e5f5$var$GREEN_LIGHT
        ],
        [
            94,
            60,
            28,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            86,
            50,
            -8,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            99,
            44,
            30,
            $eb192a108979e5f5$var$GREEN_LIGHT
        ],
        [
            99,
            33,
            12,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            50,
            84,
            -42,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            61,
            76,
            -6,
            $eb192a108979e5f5$var$GREEN_LIGHT
        ],
        [
            49,
            66,
            -42,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            59,
            58,
            -8,
            $eb192a108979e5f5$var$GREEN_MID
        ],
        [
            55,
            50,
            -25,
            $eb192a108979e5f5$var$GREEN_LIGHT
        ]
    ];
    const foliage = leaflets.map(([x, y, angle, fill])=>$eb192a108979e5f5$var$ellipseLeaf(x, y, angle, 4.2, 7.5, fill)).join('');
    return $eb192a108979e5f5$var$wrap(stems + foliage);
}
/* --- Spider plant: fountain of thin arching blades and one dangling pup. */ function $eb192a108979e5f5$var$spiderPlant() {
    const blades = [
        {
            c: [
                48,
                64
            ],
            t: [
                24,
                74
            ],
            color: $eb192a108979e5f5$var$GREEN_MID
        },
        {
            c: [
                56,
                60
            ],
            t: [
                34,
                52
            ],
            color: $eb192a108979e5f5$var$GREEN_LIGHT
        },
        {
            c: [
                64,
                56
            ],
            t: [
                48,
                34
            ],
            color: $eb192a108979e5f5$var$GREEN_MID
        },
        {
            c: [
                74,
                50
            ],
            t: [
                66,
                24
            ],
            color: $eb192a108979e5f5$var$GREEN_LIGHT
        },
        {
            c: [
                82,
                48
            ],
            t: [
                84,
                22
            ],
            color: $eb192a108979e5f5$var$GREEN_MID
        },
        {
            c: [
                88,
                52
            ],
            t: [
                100,
                30
            ],
            color: $eb192a108979e5f5$var$GREEN_LIGHT
        },
        {
            c: [
                94,
                58
            ],
            t: [
                116,
                44
            ],
            color: $eb192a108979e5f5$var$GREEN_MID
        },
        {
            c: [
                100,
                66
            ],
            t: [
                130,
                62
            ],
            color: $eb192a108979e5f5$var$GREEN_LIGHT
        },
        {
            c: [
                70,
                72
            ],
            t: [
                60,
                48
            ],
            color: $eb192a108979e5f5$var$GREEN_DEEP
        },
        {
            c: [
                88,
                72
            ],
            t: [
                98,
                50
            ],
            color: $eb192a108979e5f5$var$GREEN_DEEP
        }
    ];
    const foliage = blades.map((blade)=>`<path d="M80 101 Q ${blade.c[0]} ${blade.c[1]} ${blade.t[0]} ${blade.t[1]}" fill="none" stroke="${blade.color}" stroke-width="3" stroke-linecap="round"/>`).join('');
    const pup = `
    <path d="M86 100 C 112 90 128 100 132 122" fill="none" stroke="${$eb192a108979e5f5$var$STOLON}" stroke-width="2.2" stroke-linecap="round"/>
    <path d="M132 122 L 124 134 M132 122 L 130 138 M132 122 L 138 136 M132 122 L 142 130" stroke="${$eb192a108979e5f5$var$GREEN_MID}" stroke-width="2.4" stroke-linecap="round" fill="none"/>
    <circle cx="117" cy="94" r="2.4" fill="#fffdf7" stroke="${$eb192a108979e5f5$var$SUN_EDGE}" stroke-width="1.4"/>`;
    return $eb192a108979e5f5$var$wrap(foliage, pup);
}
/* --- Boston fern: computed fishbone fronds spilling in every direction. */ function $eb192a108979e5f5$var$bostonFern() {
    const base = [
        80,
        102
    ];
    const fronds = [
        {
            c: [
                50,
                72
            ],
            t: [
                26,
                62
            ]
        },
        {
            c: [
                58,
                54
            ],
            t: [
                38,
                34
            ]
        },
        {
            c: [
                72,
                46
            ],
            t: [
                62,
                22
            ]
        },
        {
            c: [
                88,
                46
            ],
            t: [
                96,
                20
            ]
        },
        {
            c: [
                100,
                56
            ],
            t: [
                122,
                34
            ]
        },
        {
            c: [
                108,
                74
            ],
            t: [
                134,
                64
            ]
        }
    ];
    const parts = [];
    fronds.forEach((frond, index)=>{
        const color = index % 2 === 0 ? $eb192a108979e5f5$var$GREEN_MID : $eb192a108979e5f5$var$GREEN_LIGHT;
        parts.push(`<path d="M${base[0]} ${base[1]} Q ${frond.c[0]} ${frond.c[1]} ${frond.t[0]} ${frond.t[1]}" fill="none" stroke="${$eb192a108979e5f5$var$GREEN_DEEP}" stroke-width="2.6" stroke-linecap="round"/>`);
        for(let t = 0.2; t <= 0.94; t += 0.105){
            const [x, y] = $eb192a108979e5f5$var$quadPoint(base, frond.c, frond.t, t);
            const [nx, ny] = $eb192a108979e5f5$var$quadNormal(base, frond.c, frond.t, t);
            const length = 8.5 * (1 - t) + 2.5;
            parts.push(`<path d="M${$eb192a108979e5f5$var$round(x - nx * length)} ${$eb192a108979e5f5$var$round(y - ny * length)} L${$eb192a108979e5f5$var$round(x + nx * length)} ${$eb192a108979e5f5$var$round(y + ny * length)}" stroke="${color}" stroke-width="2.4" stroke-linecap="round"/>`);
        }
    });
    return $eb192a108979e5f5$var$wrap(parts.join(''));
}
/* --- Calathea orbifolia: broad round leaves with banded stripes. */ function $eb192a108979e5f5$var$calatheaLeaf(x, y, angle, scale, fill, stripe) {
    return `<g transform="translate(${x} ${y}) rotate(${angle}) scale(${scale})">
    <ellipse cx="0" cy="0" rx="19" ry="25" fill="${fill}"/>
    <path d="M-13 -10 Q0 -18 13 -10 M-15 0 Q0 -8 15 0 M-13 10 Q0 2 13 10" fill="none" stroke="${stripe}" stroke-width="2.4" stroke-linecap="round" opacity="0.85"/>
    <path d="M0 -23 L0 23" stroke="${stripe}" stroke-width="1.6" opacity="0.5"/>
  </g>`;
}
function $eb192a108979e5f5$var$calathea() {
    const stems = [
        'M74 102 C 66 88 60 74 57 62',
        'M82 102 C 84 82 86 62 88 48',
        'M88 102 C 98 92 104 82 108 74',
        'M78 102 C 74 94 72 88 72 84'
    ].map((d)=>`<path d="${d}" fill="none" stroke="${$eb192a108979e5f5$var$GREEN_DEEP}" stroke-width="2.6" stroke-linecap="round"/>`).join('');
    const leaves = [
        $eb192a108979e5f5$var$calatheaLeaf(56, 56, -18, 1, $eb192a108979e5f5$var$GREEN_MID, '#dcefdf'),
        $eb192a108979e5f5$var$calatheaLeaf(72, 80, -4, 0.8, $eb192a108979e5f5$var$PLUM, $eb192a108979e5f5$var$PLUM_STRIPE),
        $eb192a108979e5f5$var$calatheaLeaf(88, 42, 6, 1.05, $eb192a108979e5f5$var$GREEN_DEEP, $eb192a108979e5f5$var$GREEN_LIGHT),
        $eb192a108979e5f5$var$calatheaLeaf(110, 68, 24, 0.92, $eb192a108979e5f5$var$GREEN_MID, '#dcefdf')
    ].join('');
    return $eb192a108979e5f5$var$wrap(stems + leaves);
}
/* --- Parlour palm: slim canes crowned with computed blade fans. */ function $eb192a108979e5f5$var$palmFan(tip, direction, size, color) {
    const blades = [];
    const count = 7;
    for(let i = 0; i < count; i += 1){
        const rel = i / (count - 1) - 0.5;
        const angle = direction + rel * 150;
        const radians = angle * Math.PI / 180;
        const length = size - Math.abs(rel) * 6;
        const droop = 2 + Math.abs(rel) * 6;
        const endX = tip[0] + Math.cos(radians) * length;
        const endY = tip[1] + Math.sin(radians) * length + droop;
        blades.push(`<path d="M${tip[0]} ${tip[1]} Q ${$eb192a108979e5f5$var$round((tip[0] + endX) / 2)} ${$eb192a108979e5f5$var$round((tip[1] + endY) / 2 - 4)} ${$eb192a108979e5f5$var$round(endX)} ${$eb192a108979e5f5$var$round(endY)}" fill="none" stroke="${color}" stroke-width="2.4" stroke-linecap="round"/>`);
    }
    return blades.join('');
}
function $eb192a108979e5f5$var$parlourPalm() {
    const stems = [
        'M68 104 Q 60 78 52 48',
        'M82 104 Q 82 68 84 32',
        'M96 104 Q 104 80 110 54'
    ].map((d)=>`<path d="${d}" fill="none" stroke="${$eb192a108979e5f5$var$GREEN_DEEP}" stroke-width="2.8" stroke-linecap="round"/>`).join('');
    const sideLeaves = [
        'M64 92 L 52 86',
        'M70 78 L 60 70',
        'M82 86 L 72 80',
        'M82 66 L 92 58',
        'M94 90 L 104 84',
        'M100 74 L 110 70'
    ].map((d)=>`<path d="${d}" stroke="${$eb192a108979e5f5$var$GREEN_MID}" stroke-width="2.2" stroke-linecap="round"/>`).join('');
    const fans = $eb192a108979e5f5$var$palmFan([
        52,
        48
    ], -101, 23, $eb192a108979e5f5$var$GREEN_MID) + $eb192a108979e5f5$var$palmFan([
        84,
        32
    ], -88, 25, $eb192a108979e5f5$var$GREEN_DEEP) + $eb192a108979e5f5$var$palmFan([
        110,
        54
    ], -74, 22, $eb192a108979e5f5$var$GREEN_MID);
    return $eb192a108979e5f5$var$wrap(stems + sideLeaves + fans);
}
/* --- Aloe vera: plump speckled rosette. */ function $eb192a108979e5f5$var$aloeVera() {
    const leaves = [
        {
            d: 'M64 102 C50 92 40 74 44 58 C56 66 68 84 73 102 Z',
            fill: $eb192a108979e5f5$var$GREEN_DEEP
        },
        {
            d: 'M92 102 C102 90 112 76 116 62 C119 78 108 94 99 102 Z',
            fill: $eb192a108979e5f5$var$GREEN_DEEP
        },
        {
            d: 'M71 102 C64 82 63 60 69 46 C76 60 78 82 80 102 Z',
            fill: $eb192a108979e5f5$var$GREEN_MID
        },
        {
            d: 'M86 102 C90 80 94 60 100 48 C104 62 98 86 93 102 Z',
            fill: $eb192a108979e5f5$var$GREEN_MID
        },
        {
            d: 'M79 102 C77 72 79 46 83 34 C88 48 89 76 88 102 Z',
            fill: $eb192a108979e5f5$var$GREEN_MID
        }
    ];
    const speckles = [
        [
            70,
            70
        ],
        [
            74,
            58
        ],
        [
            82,
            54
        ],
        [
            84,
            72
        ],
        [
            96,
            66
        ],
        [
            100,
            56
        ],
        [
            66,
            82
        ],
        [
            90,
            86
        ],
        [
            83,
            42
        ]
    ];
    const shapes = leaves.map((leaf)=>`<path d="${leaf.d}" fill="${leaf.fill}"/>`).join('');
    const dots = speckles.map(([x, y])=>`<circle cx="${x}" cy="${y}" r="1.5" fill="#ffffff" opacity="0.42"/>`).join('');
    return $eb192a108979e5f5$var$wrap(shapes + dots);
}
/* --- Fallback sprout for plant ids without a bespoke drawing. */ function $eb192a108979e5f5$var$sprout() {
    return $eb192a108979e5f5$var$wrap(`
    <path d="M80 102 C 79 86 80 72 80 58" fill="none" stroke="${$eb192a108979e5f5$var$GREEN_DEEP}" stroke-width="3" stroke-linecap="round"/>
    <path d="M80 76 C 70 72 62 62 62 50 C 74 52 80 64 80 74 Z" fill="${$eb192a108979e5f5$var$GREEN_MID}"/>
    <path d="M80 68 C 82 56 90 47 101 45 C 101 57 90 66 81 68 Z" fill="${$eb192a108979e5f5$var$GREEN_DEEP}"/>
    <path d="M80 58 C 76 52 76 46 79 41 C 83 46 83 54 80 58 Z" fill="${$eb192a108979e5f5$var$GREEN_LIGHT}"/>`);
}
const $eb192a108979e5f5$var$illustrationsById = {
    'snake-plant': $eb192a108979e5f5$var$snakePlant,
    'golden-pothos': $eb192a108979e5f5$var$goldenPothos,
    'zz-plant': $eb192a108979e5f5$var$zzPlant,
    'spider-plant': $eb192a108979e5f5$var$spiderPlant,
    'boston-fern': $eb192a108979e5f5$var$bostonFern,
    calathea: $eb192a108979e5f5$var$calathea,
    'parlour-palm': $eb192a108979e5f5$var$parlourPalm,
    'aloe-vera': $eb192a108979e5f5$var$aloeVera
};
function $eb192a108979e5f5$export$956f23f18066d649(plantId) {
    const draw = $eb192a108979e5f5$var$illustrationsById[plantId] ?? $eb192a108979e5f5$var$sprout;
    return draw();
}
function $eb192a108979e5f5$export$59cd8be3e68df9a8(flip = false) {
    const leafShape = 'M0 0 C -5 -10 -4 -20 3 -27 C 10 -19 8 -7 0 0 Z';
    const leaves = [
        {
            x: 30,
            y: 76,
            a: -54,
            s: 1.05,
            fill: $eb192a108979e5f5$var$GREEN_LIGHT
        },
        {
            x: 60,
            y: 66,
            a: 24,
            s: 0.95,
            fill: '#cde6c8'
        },
        {
            x: 90,
            y: 54,
            a: -46,
            s: 1.15,
            fill: $eb192a108979e5f5$var$SUN_EDGE
        },
        {
            x: 120,
            y: 42,
            a: 32,
            s: 0.95,
            fill: $eb192a108979e5f5$var$GREEN_LIGHT
        },
        {
            x: 148,
            y: 30,
            a: -38,
            s: 1.05,
            fill: '#cde6c8'
        },
        {
            x: 174,
            y: 18,
            a: 26,
            s: 0.85,
            fill: $eb192a108979e5f5$var$GREEN_LIGHT
        }
    ].map((leaf)=>`<g transform="translate(${leaf.x} ${leaf.y}) rotate(${leaf.a}) scale(${leaf.s})"><path d="${leafShape}" fill="${leaf.fill}"/></g>`).join('');
    const transform = flip ? ' transform="scale(-1 1) translate(-200 0)"' : '';
    return `<svg viewBox="0 0 200 90" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g${transform}><path d="M6 88 C 58 76 128 60 192 10" fill="none" stroke="#9fca9b" stroke-width="3" stroke-linecap="round"/>${leaves}</g></svg>`;
}


function $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8(value) {
    return value.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#39;');
}
function $0d2c0e7c63c76ea0$export$9a328bbde6508c84(template, values) {
    return Object.entries(values).reduce((result, [key, value])=>result.replaceAll(`{${key}}`, value), template);
}
function $0d2c0e7c63c76ea0$export$ce239f705f93fc16(id, html) {
    const target = document.getElementById(id);
    if (!target) throw new Error(`Missing mount point: #${id}`);
    target.innerHTML = html;
    return target;
}




function $e5d388c391c9b664$export$8dab547884cce3d0(plant) {
    const values = {
        plant: plant.name,
        botanical: plant.botanical,
        shop: (0, $639c424d7abca305$export$6193722c8094ee5f).name
    };
    const subject = encodeURIComponent((0, $0d2c0e7c63c76ea0$export$9a328bbde6508c84)((0, $639c424d7abca305$export$6193722c8094ee5f).reserve.subject, values));
    const body = encodeURIComponent((0, $0d2c0e7c63c76ea0$export$9a328bbde6508c84)((0, $639c424d7abca305$export$6193722c8094ee5f).reserve.body, values));
    return `mailto:${(0, $639c424d7abca305$export$6193722c8094ee5f).email}?subject=${subject}&body=${body}`;
}


function $a2117696e3af18b8$export$f167ba58351acedf() {
    const copy = (0, $639c424d7abca305$export$6193722c8094ee5f).sections.catalogue;
    return `
    <div class="section-inner">
      <div class="section-head">
        <p class="kicker">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.kicker)}</p>
        <h2 id="catalogue-title">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.title)}</h2>
        <p class="lede">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.lede)}</p>
      </div>
      <div class="catalogue-grid">${(0, $639c424d7abca305$export$1ce40965716f5168).map($a2117696e3af18b8$var$renderPlantCard).join('')}</div>
    </div>`;
}
function $a2117696e3af18b8$var$renderPlantCard(plant) {
    const lightChips = plant.light.map((level)=>`<li class="chip chip-light">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$8d0bb65fc38d32db).tagLabels.light[level])}</li>`).join('');
    const waterChips = plant.water.map((habit)=>`<li class="chip chip-water">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$8d0bb65fc38d32db).tagLabels.water[habit])}</li>`).join('');
    const petChip = plant.petSafe ? `<li class="chip chip-safe">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$8d0bb65fc38d32db).tagLabels.petSafe)}</li>` : `<li class="chip chip-warn">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$8d0bb65fc38d32db).tagLabels.notPetSafe)}</li>`;
    const reserveLabel = (0, $639c424d7abca305$export$6193722c8094ee5f).sections.catalogue.reserveLabel;
    return `
    <article class="plant-card">
      <div class="plant-illustration">${(0, $eb192a108979e5f5$export$956f23f18066d649)(plant.id)}</div>
      <div class="plant-head">
        <h3 class="plant-name">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(plant.name)}</h3>
        <span class="price-pill">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).currencySymbol)}${plant.price}</span>
      </div>
      <p class="botanical">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(plant.botanical)}</p>
      <p class="personality">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(plant.personality)}</p>
      <ul class="tag-list" aria-label="Care tags">${lightChips}${waterChips}${petChip}</ul>
      <a class="reserve-link" href="${(0, $e5d388c391c9b664$export$8dab547884cce3d0)(plant)}" aria-label="${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(`${reserveLabel}: ${plant.name}, by email`)}"><span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(reserveLabel)}</span>${0, $268f2417e2e7b740$export$fb9188ad99e3f6b}</a>
    </article>`;
}




function $c940483bd606cfe9$export$702b8030d7334eb() {
    const copy = (0, $639c424d7abca305$export$6193722c8094ee5f).sections.faq;
    const items = (0, $639c424d7abca305$export$6193722c8094ee5f).faqs.map((faq, index)=>`
      <details class="faq-item"${index === 0 ? ' open' : ''}>
        <summary>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(faq.question)}<span class="faq-marker" aria-hidden="true">+</span></summary>
        <p>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(faq.answer)}</p>
      </details>`).join('');
    return `
    <div class="section-inner faq-inner">
      <div class="section-head">
        <p class="kicker">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.kicker)}</p>
        <h2 id="faq-title">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.title)}</h2>
      </div>
      <div class="faq-list">${items}</div>
    </div>`;
}
function $c940483bd606cfe9$export$5dda337a4760c228() {
    const data = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: (0, $639c424d7abca305$export$6193722c8094ee5f).faqs.map((faq)=>({
                '@type': 'Question',
                name: faq.question,
                acceptedAnswer: {
                    '@type': 'Answer',
                    text: faq.answer
                }
            }))
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
}





function $2e2da72dc3b27c57$export$f78842bd8df93f12() {
    const copy = (0, $639c424d7abca305$export$6193722c8094ee5f).sections.footer;
    const socials = (0, $639c424d7abca305$export$6193722c8094ee5f).socials.map((link)=>`<a href="${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(link.href)}" rel="noreferrer">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(link.label)}</a>`).join('');
    const year = new Date().getFullYear();
    return `
    <div class="footer-inner">
      <div class="footer-brand">
        <span class="brand-mark">${0, $268f2417e2e7b740$export$9d5c241fe9ee2567}</span>
        <span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).name)}</span>
      </div>
      <p class="footer-line">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.line)}</p>
      <div class="footer-contact">
        <a href="mailto:${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).email)}">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).email)}</a>
        <span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).address)}</span>
        ${socials}
      </div>
      <p class="footer-small">&copy; ${year} ${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).name)}. ${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.smallPrint)}</p>
    </div>`;
}





function $7e7a53ae46f8760f$export$31c38b89870eadc8() {
    const nav = (0, $639c424d7abca305$export$6193722c8094ee5f).navigation.map((link)=>`<a href="${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(link.href)}">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(link.label)}</a>`).join('');
    return `
    <div class="header-inner">
      <a class="brand" href="#quiz">
        <span class="brand-mark">${0, $268f2417e2e7b740$export$9d5c241fe9ee2567}</span>
        <span class="brand-text">
          <span class="brand-name">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).name)}</span>
          <span class="brand-tagline">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).tagline)}</span>
        </span>
      </a>
      <nav class="site-nav" aria-label="Site">${nav}</nav>
      <a class="button button-ghost header-mail" href="mailto:${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).email)}">${0, $268f2417e2e7b740$export$63cea22b3e24bc8}<span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).emailButtonLabel)}</span></a>
    </div>`;
}





const $9d70ee1ff7d4cba5$export$c67515368f07284d = [
    'low',
    'medium',
    'bright'
];
const $9d70ee1ff7d4cba5$export$f280c4c3e58c52f1 = [
    'forgetful',
    'regular',
    'attentive'
];
const $9d70ee1ff7d4cba5$export$a89275edfa6aa89f = [
    'yes',
    'no'
];
function $9d70ee1ff7d4cba5$export$80b063c46b9050b4(value) {
    return $9d70ee1ff7d4cba5$export$c67515368f07284d.includes(value);
}
function $9d70ee1ff7d4cba5$export$415276f24c76c7b(value) {
    return $9d70ee1ff7d4cba5$export$f280c4c3e58c52f1.includes(value);
}
function $9d70ee1ff7d4cba5$export$f50777048e2af09(value) {
    return $9d70ee1ff7d4cba5$export$a89275edfa6aa89f.includes(value);
}
function $9d70ee1ff7d4cba5$export$9569565a7ac14e8e(answers) {
    return answers.light !== undefined && answers.care !== undefined && answers.pets !== undefined;
}
function $9d70ee1ff7d4cba5$export$f37f4b0b4d2e2142(answers) {
    return [
        answers.light,
        answers.care,
        answers.pets
    ].filter((value)=>value !== undefined).length;
}



function $a5b1cf1f5d18ed6b$export$6df31f41db9b00c8() {
    const copy = (0, $639c424d7abca305$export$6193722c8094ee5f).sections.quiz;
    const questions = (0, $639c424d7abca305$export$8d0bb65fc38d32db).questions.map((question, index)=>$a5b1cf1f5d18ed6b$var$renderQuestion(question, index)).join('');
    const bench = (0, $639c424d7abca305$export$1ce40965716f5168).map((plant)=>`<span class="bench-mini" title="${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(plant.name)}">${(0, $eb192a108979e5f5$export$956f23f18066d649)(plant.id)}</span>`).join('');
    return `
    <div class="section-inner quiz-inner">
      <div class="quiz-intro">
        <p class="kicker">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.kicker)}</p>
        <h1 class="quiz-title" id="quiz-title">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.title)}</h1>
        <p class="lede">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.lede)}</p>
        <p class="quiz-url-note">${0, $268f2417e2e7b740$export$ebcd2be1028c1c9c}<span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.urlNote)}</span></p>
        <div class="quiz-bench" aria-hidden="true">${bench}</div>
        <p class="quiz-bench-line">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.benchLine)}</p>
      </div>
      <form class="quiz-form" id="quiz-form">${questions}</form>
    </div>`;
}
function $a5b1cf1f5d18ed6b$var$renderQuestion(question, index) {
    const options = question.options.map((option)=>`
      <label class="answer-card">
        <input class="visually-hidden" type="radio" name="${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(question.id)}" value="${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(option.value)}" />
        <span class="answer-icon">${(0, $268f2417e2e7b740$export$29eafeec5feb04d7)[option.icon] ?? ''}</span>
        <span class="answer-copy">
          <span class="answer-label">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(option.label)}</span>
          <span class="answer-desc">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(option.description)}</span>
        </span>
      </label>`).join('');
    return `
    <fieldset class="quiz-question">
      <legend><span class="question-number" aria-hidden="true">${index + 1}</span><span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(question.legend)}</span></legend>
      <p class="question-hint">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(question.hint)}</p>
      <div class="answer-options answer-options-${question.options.length}">${options}</div>
    </fieldset>`;
}
function $a5b1cf1f5d18ed6b$export$3206fdc82dca5593(initial, onChange) {
    const form = document.getElementById('quiz-form');
    if (!(form instanceof HTMLFormElement)) throw new Error('Quiz form failed to render');
    $a5b1cf1f5d18ed6b$var$applyAnswers(form, initial);
    form.addEventListener('change', ()=>{
        onChange($a5b1cf1f5d18ed6b$var$readAnswers(form));
    });
}
function $a5b1cf1f5d18ed6b$var$applyAnswers(form, answers) {
    for (const [name, value] of Object.entries(answers)){
        if (value === undefined) continue;
        const input = form.querySelector(`input[name="${name}"][value="${value}"]`);
        if (input instanceof HTMLInputElement) input.checked = true;
    }
}
function $a5b1cf1f5d18ed6b$var$readAnswers(form) {
    const data = new FormData(form);
    const answers = {};
    const light = data.get('light');
    if (typeof light === 'string' && (0, $9d70ee1ff7d4cba5$export$80b063c46b9050b4)(light)) answers.light = light;
    const care = data.get('care');
    if (typeof care === 'string' && (0, $9d70ee1ff7d4cba5$export$415276f24c76c7b)(care)) answers.care = care;
    const pets = data.get('pets');
    if (typeof pets === 'string' && (0, $9d70ee1ff7d4cba5$export$f50777048e2af09)(pets)) answers.pets = pets;
    return answers;
}









function $32b6f24019a66622$export$b17bcfab39f17d41(plant, answers) {
    const reasons = [];
    if (plant.light.includes(answers.light)) reasons.push((0, $639c424d7abca305$export$8d0bb65fc38d32db).reasons.light[answers.light]);
    if (plant.water.includes(answers.care)) reasons.push((0, $639c424d7abca305$export$8d0bb65fc38d32db).reasons.care[answers.care]);
    if (answers.pets === 'yes' && plant.petSafe) reasons.push((0, $639c424d7abca305$export$8d0bb65fc38d32db).reasons.pets.yes);
    return reasons;
}
function $32b6f24019a66622$export$7169398dd02a782(plant, answers) {
    const caveats = [];
    if (!plant.light.includes(answers.light)) caveats.push($32b6f24019a66622$var$wantsMoreThanOffered(plant.light, answers.light, (0, $9d70ee1ff7d4cba5$export$c67515368f07284d)) ? (0, $639c424d7abca305$export$8d0bb65fc38d32db).mismatches.light.brighter : (0, $639c424d7abca305$export$8d0bb65fc38d32db).mismatches.light.dimmer);
    if (!plant.water.includes(answers.care)) caveats.push($32b6f24019a66622$var$wantsMoreThanOffered(plant.water, answers.care, (0, $9d70ee1ff7d4cba5$export$f280c4c3e58c52f1)) ? (0, $639c424d7abca305$export$8d0bb65fc38d32db).mismatches.care.more : (0, $639c424d7abca305$export$8d0bb65fc38d32db).mismatches.care.less);
    return caveats;
}
function $32b6f24019a66622$var$wantsMoreThanOffered(tolerated, offered, scale) {
    const lowestTolerated = Math.min(...tolerated.map((value)=>scale.indexOf(value)));
    return lowestTolerated > scale.indexOf(offered);
}


const $0d49a4739499da92$export$570e5bc4bf0833bd = 2;
const $0d49a4739499da92$export$9ae6e0885066ffe5 = 3;
const $0d49a4739499da92$export$ff161b70fe2012ac = 4;
function $0d49a4739499da92$export$934cfb9ce0bab2ff(plant, answers) {
    return plant.light.includes(answers.light) && plant.water.includes(answers.care) && (answers.pets === 'no' || plant.petSafe);
}
function $0d49a4739499da92$export$b3a3b5873a6af40a(plant, answers) {
    const checks = [
        plant.light.includes(answers.light),
        plant.water.includes(answers.care),
        answers.pets === 'no' || plant.petSafe
    ];
    return checks.filter(Boolean).length;
}
function $0d49a4739499da92$var$toCard(plant, answers, exact) {
    return {
        plant: plant,
        exact: exact,
        reasons: (0, $32b6f24019a66622$export$b17bcfab39f17d41)(plant, answers),
        caveats: exact ? [] : (0, $32b6f24019a66622$export$7169398dd02a782)(plant, answers)
    };
}
function $0d49a4739499da92$export$832294350d7b9717(plants, answers) {
    const pool = answers.pets === 'yes' ? plants.filter((plant)=>plant.petSafe) : plants;
    const exact = pool.filter((plant)=>$0d49a4739499da92$export$934cfb9ce0bab2ff(plant, answers));
    if (exact.length >= $0d49a4739499da92$export$570e5bc4bf0833bd) return {
        cards: exact.slice(0, $0d49a4739499da92$export$ff161b70fe2012ac).map((plant)=>$0d49a4739499da92$var$toCard(plant, answers, true)),
        usedFallback: false
    };
    const nearest = pool.filter((plant)=>!$0d49a4739499da92$export$934cfb9ce0bab2ff(plant, answers)).sort((a, b)=>$0d49a4739499da92$export$b3a3b5873a6af40a(b, answers) - $0d49a4739499da92$export$b3a3b5873a6af40a(a, answers)).slice(0, $0d49a4739499da92$export$9ae6e0885066ffe5 - exact.length);
    return {
        cards: [
            ...exact.map((plant)=>$0d49a4739499da92$var$toCard(plant, answers, true)),
            ...nearest.map((plant)=>$0d49a4739499da92$var$toCard(plant, answers, false))
        ],
        usedFallback: true
    };
}



const $f0ae661fa9de05f7$var$copy = (0, $639c424d7abca305$export$6193722c8094ee5f).sections.results;
function $f0ae661fa9de05f7$export$2a1050de14a7376c() {
    const shell = `
    <div class="section-inner">
      <div class="section-head">
        <p class="kicker">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.kicker)}</p>
        <h2 id="results-title">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.title)}</h2>
      </div>
      <p class="results-status" id="results-status" role="status"></p>
      <div class="results-body" id="results-body"></div>
    </div>`;
    const section = (0, $0d2c0e7c63c76ea0$export$ce239f705f93fc16)('results', shell);
    section.addEventListener('click', $f0ae661fa9de05f7$var$handleCopyClick);
}
function $f0ae661fa9de05f7$export$2496d45061dc3e72(answers) {
    const status = document.getElementById('results-status');
    const body = document.getElementById('results-body');
    if (!status || !body) return;
    if (!(0, $9d70ee1ff7d4cba5$export$9569565a7ac14e8e)(answers)) {
        status.textContent = (0, $0d2c0e7c63c76ea0$export$9a328bbde6508c84)($f0ae661fa9de05f7$var$copy.progressTemplate, {
            answered: String((0, $9d70ee1ff7d4cba5$export$f37f4b0b4d2e2142)(answers))
        });
        body.innerHTML = $f0ae661fa9de05f7$var$renderPlaceholder();
        return;
    }
    const outcome = (0, $0d49a4739499da92$export$832294350d7b9717)((0, $639c424d7abca305$export$1ce40965716f5168), answers);
    status.textContent = (0, $0d2c0e7c63c76ea0$export$9a328bbde6508c84)($f0ae661fa9de05f7$var$copy.completeTemplate, {
        count: String(outcome.cards.length)
    });
    const note = outcome.usedFallback ? `<p class="results-note">${0, $268f2417e2e7b740$export$d37638154c887af2}<span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.fallbackNote)}</span></p>` : '';
    body.innerHTML = `
    ${note}
    <div class="results-grid results-grid-${outcome.cards.length}">${outcome.cards.map($f0ae661fa9de05f7$var$renderMatchCard).join('')}</div>
    <div class="results-actions">
      <button class="button button-ghost" type="button" data-copy-link>${0, $268f2417e2e7b740$export$ebcd2be1028c1c9c}<span data-copy-label>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.copyLinkLabel)}</span></button>
      <p class="results-honesty">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.honestyNote)}</p>
    </div>`;
}
function $f0ae661fa9de05f7$var$renderPlaceholder() {
    return `
    <div class="results-placeholder">
      <div class="placeholder-illustration">${(0, $eb192a108979e5f5$export$956f23f18066d649)('sprout')}</div>
      <div>
        <h3>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.placeholderTitle)}</h3>
        <p>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.placeholderBody)}</p>
      </div>
    </div>`;
}
function $f0ae661fa9de05f7$var$renderMatchCard(card) {
    const { plant: plant } = card;
    const flag = card.exact ? '' : `<p class="close-flag">${0, $268f2417e2e7b740$export$d37638154c887af2}<span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.closeFlag)}</span></p>`;
    const reasons = card.reasons.map((reason)=>`<li class="reason">${0, $268f2417e2e7b740$export$58d09ec3e03f3a63}<span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(reason)}</span></li>`).join('');
    const caveats = card.caveats.map((caveat)=>`<li class="reason reason-caveat">${0, $268f2417e2e7b740$export$d37638154c887af2}<span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(caveat)}</span></li>`).join('');
    const petChip = plant.petSafe ? `<span class="chip chip-safe">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$8d0bb65fc38d32db).tagLabels.petSafe)}</span>` : `<span class="chip chip-warn">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$8d0bb65fc38d32db).tagLabels.notPetSafe)}</span>`;
    return `
    <article class="match-card${card.exact ? '' : ' match-card-close'}">
      ${flag}
      <div class="match-illustration">${(0, $eb192a108979e5f5$export$956f23f18066d649)(plant.id)}</div>
      <h3 class="plant-name">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(plant.name)}</h3>
      <p class="botanical">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(plant.botanical)}</p>
      <div class="match-meta">
        <span class="price-pill">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).currencySymbol)}${plant.price}</span>
        ${petChip}
      </div>
      <ul class="reason-list">${reasons}${caveats}</ul>
      <p class="personality">&ldquo;${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(plant.personality)}&rdquo;</p>
      <a class="button button-primary" href="${(0, $e5d388c391c9b664$export$8dab547884cce3d0)(plant)}" aria-label="${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(`${$f0ae661fa9de05f7$var$copy.reserveLabel}: ${plant.name}, by email`)}">${0, $268f2417e2e7b740$export$63cea22b3e24bc8}<span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)($f0ae661fa9de05f7$var$copy.reserveLabel)}</span></a>
    </article>`;
}
function $f0ae661fa9de05f7$var$handleCopyClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('[data-copy-link]');
    if (!(button instanceof HTMLButtonElement)) return;
    const label = button.querySelector('[data-copy-label]');
    if (!label) return;
    navigator.clipboard.writeText(window.location.href).then(()=>$f0ae661fa9de05f7$var$flashLabel(label, $f0ae661fa9de05f7$var$copy.copiedLabel)).catch(()=>$f0ae661fa9de05f7$var$flashLabel(label, $f0ae661fa9de05f7$var$copy.copyFailedLabel));
}
function $f0ae661fa9de05f7$var$flashLabel(label, message) {
    label.textContent = message;
    window.setTimeout(()=>{
        label.textContent = $f0ae661fa9de05f7$var$copy.copyLinkLabel;
    }, 2000);
}






function $897da46559046c8e$export$3c9386ddc11fb14d() {
    const copy = (0, $639c424d7abca305$export$6193722c8094ee5f).sections.visit;
    const hours = (0, $639c424d7abca305$export$6193722c8094ee5f).hours.map((row)=>`<div class="hours-row"><dt>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(row.days)}</dt><dd>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(row.time)}</dd></div>`).join('');
    return `
    <div class="section-inner visit-inner">
      <div class="visit-copy">
        <p class="kicker">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.kicker)}</p>
        <h2 id="visit-title">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.title)}</h2>
        <p class="lede">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.lede)}</p>
        <p class="visit-email-lead">${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.emailLead)}</p>
        <a class="button button-primary" href="mailto:${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).email)}">${0, $268f2417e2e7b740$export$63cea22b3e24bc8}<span>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).email)}</span></a>
        <div class="visit-sprig" aria-hidden="true">${(0, $eb192a108979e5f5$export$59cd8be3e68df9a8)(true)}</div>
      </div>
      <div class="visit-cards">
        <div class="visit-card">
          <h3>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.addressTitle)}</h3>
          <p>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).name)}<br />${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)((0, $639c424d7abca305$export$6193722c8094ee5f).address)}</p>
        </div>
        <div class="visit-card">
          <h3>${(0, $0d2c0e7c63c76ea0$export$4cf11838cdc2a8a8)(copy.hoursTitle)}</h3>
          <dl class="hours-list">${hours}</dl>
        </div>
      </div>
    </div>`;
}






function $1ef5f7f67db4ade1$export$91fcf781489cfed4(search) {
    const params = new URLSearchParams(search);
    const answers = {};
    const light = params.get('light');
    if (light !== null && (0, $9d70ee1ff7d4cba5$export$80b063c46b9050b4)(light)) answers.light = light;
    const care = params.get('care');
    if (care !== null && (0, $9d70ee1ff7d4cba5$export$415276f24c76c7b)(care)) answers.care = care;
    const pets = params.get('pets');
    if (pets !== null && (0, $9d70ee1ff7d4cba5$export$f50777048e2af09)(pets)) answers.pets = pets;
    return answers;
}
function $1ef5f7f67db4ade1$export$22e509caea409b61(answers) {
    const params = new URLSearchParams();
    if (answers.light) params.set('light', answers.light);
    if (answers.care) params.set('care', answers.care);
    if (answers.pets) params.set('pets', answers.pets);
    return params.toString();
}
function $1ef5f7f67db4ade1$export$34d990c7198433bb(answers) {
    const url = new URL(window.location.href);
    url.search = $1ef5f7f67db4ade1$export$22e509caea409b61(answers);
    window.history.replaceState(null, '', url);
}


let $a3271212a63e8467$var$resultsWereComplete = false;
function $a3271212a63e8467$var$handleAnswersChange(answers) {
    (0, $1ef5f7f67db4ade1$export$34d990c7198433bb)(answers);
    (0, $f0ae661fa9de05f7$export$2496d45061dc3e72)(answers);
    const nowComplete = (0, $9d70ee1ff7d4cba5$export$9569565a7ac14e8e)(answers);
    if (nowComplete && !$a3271212a63e8467$var$resultsWereComplete) $a3271212a63e8467$var$scrollToResults();
    $a3271212a63e8467$var$resultsWereComplete = nowComplete;
}
function $a3271212a63e8467$var$scrollToResults() {
    const section = document.getElementById('results');
    if (!section) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    section.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
    });
}
function $a3271212a63e8467$var$init() {
    document.title = `${(0, $639c424d7abca305$export$6193722c8094ee5f).sections.quiz.title} \u{2014} ${(0, $639c424d7abca305$export$6193722c8094ee5f).name}`;
    (0, $0d2c0e7c63c76ea0$export$ce239f705f93fc16)('site-header', (0, $7e7a53ae46f8760f$export$31c38b89870eadc8)());
    (0, $0d2c0e7c63c76ea0$export$ce239f705f93fc16)('quiz', (0, $a5b1cf1f5d18ed6b$export$6df31f41db9b00c8)());
    (0, $f0ae661fa9de05f7$export$2a1050de14a7376c)();
    (0, $0d2c0e7c63c76ea0$export$ce239f705f93fc16)('catalogue', (0, $a2117696e3af18b8$export$f167ba58351acedf)());
    (0, $0d2c0e7c63c76ea0$export$ce239f705f93fc16)('faq', (0, $c940483bd606cfe9$export$702b8030d7334eb)());
    (0, $c940483bd606cfe9$export$5dda337a4760c228)();
    (0, $0d2c0e7c63c76ea0$export$ce239f705f93fc16)('visit', (0, $897da46559046c8e$export$3c9386ddc11fb14d)());
    (0, $0d2c0e7c63c76ea0$export$ce239f705f93fc16)('site-footer', (0, $2e2da72dc3b27c57$export$f78842bd8df93f12)());
    const initial = (0, $1ef5f7f67db4ade1$export$91fcf781489cfed4)(window.location.search);
    (0, $a5b1cf1f5d18ed6b$export$3206fdc82dca5593)(initial, $a3271212a63e8467$var$handleAnswersChange);
    (0, $f0ae661fa9de05f7$export$2496d45061dc3e72)(initial);
    $a3271212a63e8467$var$resultsWereComplete = (0, $9d70ee1ff7d4cba5$export$9569565a7ac14e8e)(initial);
}
$a3271212a63e8467$var$init();


//# sourceMappingURL=repository.574eb43d.js.map
